export default "__VITE_ASSET__CxHu__3d__"